/**
 * Pure CCK-credits display helpers (cck-credits-01 / T4). No I/O — unit-tested.
 */
import { CckCreditsMe } from '../types';

/**
 * Sidebar credits-indicator label. Admins aren't metered → "—"; feature dark or
 * no data → "—"; otherwise "N credits". (Expiring-soon is conveyed by colour, not
 * the text, so the position/format never shifts — UX rule.)
 */
export function cckCreditsLabel(me: CckCreditsMe | null, isAdmin: boolean): string {
  if (isAdmin) return '—';
  if (!me || !me.enabled) return '—';
  return `${me.balance.toLocaleString()} credits`;
}

/** Whole days until `iso` from `now`, rounded up; null if no date or already past-relative. */
export function daysUntil(iso: string | null, now: Date = new Date()): number | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (isNaN(t)) return null;
  const ms = t - now.getTime();
  return Math.max(0, Math.ceil(ms / 86_400_000));
}

/** Human "expires in N days" line for the soonest grant, or null when none. */
export function expiryLabel(me: CckCreditsMe | null, now: Date = new Date()): string | null {
  if (!me || !me.enabled || !me.soonest_expires_at) return null;
  const d = daysUntil(me.soonest_expires_at, now);
  if (d == null) return null;
  if (d === 0) return 'Expires today';
  return `Expires in ${d} day${d === 1 ? '' : 's'}`;
}

/** Whether the credits indicator should render in the amber "warning" tone. */
export function isExpiringSoon(me: CckCreditsMe | null): boolean {
  return !!me && me.enabled && me.expiring_soon && me.balance > 0;
}
